import type { PropsWithChildren } from "react";
import React from "react";
import type { CurrentTileContextType } from "./CurrentTileContext";
import { CurrentTileContext } from "./CurrentTileContext";

export const CurrentTileContextProvider = ({ children, ...props }: PropsWithChildren<CurrentTileContextType>) => (
  <CurrentTileContext value={props}>{children}</CurrentTileContext>
);
